import { Injectable } from '@angular/core';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { SearchableEntityBackendService } from '../searchable-entity-backend.service';
import { DetailedEntityDataService } from './detailed-entity-data.service';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders } from '@angular/common/http';
import { LoaderEnabled } from 'sce-core';



@Injectable()
export class DetailedEntityBackendService extends SearchableEntityBackendService {

  protected dataService: DetailedEntityDataService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  // service call to save an entity detail while creating
  @LoaderEnabled()
  public saveEntityforAdd(entityNumber: any, entityProperties: any, lineItems: any) {
    let request;
    // For screens with line items in details page
    if (this.dataService.entityConfig.getShowDetailLineItems()) {
      request = [{
        // 'documentId': entityNumber,
        'moduleProperties': entityProperties,
        'screenType': this.dataService.primarySearchParams.tableId,
        'detailItems': lineItems
      }];
    } else {
      request = [{
        'moduleProperties': entityProperties,
        'screenType': this.dataService.primarySearchParams.tableId
      }];
    }

    const response$ = this.http$.post(`api/setup/`, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }

  // Service call to update an entity
  public saveEntityforUpdate(entityNumber: any, entityProperties: any, lineItems: any) {
    let request;
    // For screens with line items in details page
    if (this.dataService.entityConfig.getShowDetailLineItems()) {
      request = [{
        // 'documentId': entityNumber,
        'moduleProperties': entityProperties,
        'screenType': this.dataService.primarySearchParams.tableId,
        'detailItems': lineItems
      }];
    } else {
      request = [{
        'moduleProperties': entityProperties,
        'screenType': this.dataService.primarySearchParams.tableId
      }];
    }

    const response$ = this.http$.put(`api/setup/`, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }
  public deleteEntities(itemNumber: any): Observable<Response> {
    let request;    
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: itemNumber,
    };
    const response$ = this.http$.delete('api/setup/', options)
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }
  // service call to delete an entity
  public deleteEntity(itemNumber: any): Observable<Response> {
    let request;
    // For screens with line items in details page
    if(Array.isArray(itemNumber)){
      request = itemNumber.map((itemNumber) => {
        return {
          'screenType': this.dataService.primarySearchParams.tableId,
          'moduleProperties': [{
            cName: this.dataService.primarySearchParams.idProperty,
            cVal: itemNumber
          }]
        };
      });
    }
    else {
      request = [{
        'screenType': this.dataService.primarySearchParams.tableId,
        'moduleProperties': [{
          cName: this.dataService.primarySearchParams.idProperty,
          cVal: itemNumber
        }]
      }];
    }

    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/', options)
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }

  // service call to delete selected line items of an entity
  public deleteSelectedLineItemFromEntity(itemNumber: any, selectedLineItemNumbers: any): Observable<Response> {
    const lineItemListReq = [];
    const lineItemProp = this.dataService.detailsSearchParams.idProperty;
    const moduleProp = [{ cName: this.dataService.primarySearchParams.idProperty, cVal: itemNumber }];
    selectedLineItemNumbers.forEach((lineItemNo: any) => {
      lineItemListReq.push({
        'rIdx': lineItemNo.index, 'cells': [{ cName: lineItemProp, cVal: lineItemNo.value },
        { cName: this.dataService.primarySearchParams.idProperty, cVal: itemNumber }
        ]
      });
    });
    const request = [{
      'screenType': this.dataService.primarySearchParams.tableId,
      'moduleProperties': moduleProp,
      'detailItems': lineItemListReq
    }];
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/', options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }

  // service call to delete all line items of an entity
  public deleteAllLineItemsFromEntity(itemNumber: any): Observable<Response> {

    const request = [{
      'screenType': this.dataService.primarySearchParams.tableId,
      'moduleProperties': [{
        cName: this.dataService.primarySearchParams.idProperty,
        cVal: itemNumber
      }, { cName: 'isDeleteAllItem', 'cVal': true }],
      'detailItems': []
    }];
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/', options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }

  public saveSimpleEntity(requestItems: any) {
    const response$ = this.http$.put(`api/setup/`, JSON.stringify(requestItems))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }

  // [LFWM-2125] - to get dynamic buttons based on module name and storerKey
  public getDynamicButtons(storerKey: string, moduleName: string, tableId: any): Observable<any> {
    // LFWM-3191- adding tableId.
    const response$ = this.http$.get(`api/rcmconfig/` + storerKey + `/` + moduleName + `/` + tableId)
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }

  // [2125] - - method to handle api call of dynamic button actions
  public handlingDynamicButtonAction(storerKey: string, documentKey: any, moduleName: string, actionCode: any, tableId: any, screenType: any) {
    const request = {
      'storerKey': storerKey,
      'documentKey': documentKey,
      'module': moduleName,
      'code': actionCode,
      'tableId': tableId,
      'screenType': screenType
    };
    const response$ = this.http$.post('api/rcmconfig/sp', JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.errors[0].validationCode !== 200) {
            return Observable.throw(error.error.errors['0'].validationMessage);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }

  // [LFWM-2132] - to save the edited rows in search table
  @LoaderEnabled()
  public saveEntityDetails(requestItems: any) {
    const response$ = this.http$.put(`api/setup/`, JSON.stringify(requestItems))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }
  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  // service call to save an entity detail while creating
  @LoaderEnabled()
  public saveEntityforAddWithPrivilege(entityNumber: any, entityProperties: any, lineItems: any, privilege: any) {
    let request;
    // For screens with line items in details page
    if (this.dataService.entityConfig.getShowDetailLineItems()) {
      request = [{
        // 'documentId': entityNumber,
        'moduleProperties': entityProperties,
        'screenType': this.dataService.primarySearchParams.tableId,
        'detailItems': lineItems,
        'privilege': privilege
      }];
    } else {
      request = [{
        'moduleProperties': entityProperties,
        'screenType': this.dataService.primarySearchParams.tableId,
        'privilege': privilege
      }];
    }

    const response$ = this.http$.post(`api/setup/withPriv/`, JSON.stringify(request))
      .map((response: any) => {
        return response;
        // LFWM-3191-handling 403-forbidden error.
      }).catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }

  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  // Service call to update an entity
  public saveEntityforUpdateWithPrivilege(entityNumber: any, entityProperties: any, lineItems: any, privilege: any) {
    let request;
    // For screens with line items in details page
    if (this.dataService.entityConfig.getShowDetailLineItems()) {
      request = [{
        // 'documentId': entityNumber,
        'moduleProperties': entityProperties,
        'screenType': this.dataService.primarySearchParams.tableId,
        'detailItems': lineItems,
        'privilege': privilege
      }];
    } else {
      request = [{
        'moduleProperties': entityProperties,
        'screenType': this.dataService.primarySearchParams.tableId,
        'privilege': privilege
      }];
    }

    const response$ = this.http$.put(`api/setup/withPriv/`, JSON.stringify(request))
      .map((response: any) => {
        return response;
        // LFWM-3191-handling 403-forbidden error.
      }).catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }
  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  // [LFWM-2132] - to save the edited rows in search table
  public saveEntityDetailsWithPrivilege(requestItems: any) {
    const response$ = this.http$.put(`api/setup/withPriv/`, JSON.stringify(requestItems))
      .map((response: any) => {
        return response;
        // LFWM-3191-handling 403-forbidden error.
      }).catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode && error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          } else if (error.status === 400) {
            return Observable.throw(error.error.message + ' - ' + error.error.invalidValue);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }
  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  // service call to delete an entity
  public deleteEntityWithPriv(itemNumber: any, privilege: any): Observable<Response> {
    let request;
    // For screens with line items in details page
    request = [{
      'screenType': this.dataService.primarySearchParams.tableId,
      'moduleProperties': [{
        cName: this.dataService.primarySearchParams.idProperty,
        cVal: itemNumber
      }],
      'privilege': privilege
    }];
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/withPriv/', options)
      .map((response: any) => {
        return response;
        // LFWM-3191-handling 403-forbidden error.
      }).catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }
  // service call to delete selected line items of an entity
  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  public deleteSelectedLineItemFromEntityWithPriv(itemNumber: any, selectedLineItemNumbers: any,privilege: any): Observable<Response> {
    const lineItemListReq = [];
    const lineItemProp = this.dataService.detailsSearchParams.idProperty;
    const moduleProp = [{ cName: this.dataService.primarySearchParams.idProperty, cVal: itemNumber }];
    selectedLineItemNumbers.forEach((lineItemNo: any) => {
      lineItemListReq.push({
        'rIdx': lineItemNo.index, 'cells': [{ cName: lineItemProp, cVal: lineItemNo.value },
        { cName: this.dataService.primarySearchParams.idProperty, cVal: itemNumber }
        ]
      });
    });
    const request = [{
      'screenType': this.dataService.primarySearchParams.tableId,
      'moduleProperties': moduleProp,
      'detailItems': lineItemListReq,
      'privilege': privilege
    }];
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/withPriv/', options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
      // LFWM-3191-handling 403-forbidden error.
      }).catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }

  // service call to delete all line items of an entity
  // LFWM-3191- made a new api /withPriv (replacement for setup api)
  //  to pass the privileges for checking the privileges at the backend level.
  public deleteAllLineItemsFromEntityWithPriv(itemNumber: any,privilege: any): Observable<Response> {

    const request = [{
      'screenType': this.dataService.primarySearchParams.tableId,
      'moduleProperties': [{
        cName: this.dataService.primarySearchParams.idProperty,
        cVal: itemNumber
      }, { cName: 'isDeleteAllItem', 'cVal': true }],
      'detailItems': [],
      'privilege': privilege
    }];
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete('api/setup/withPriv/', options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
      })
      // LFWM-3191-handling 403-forbidden error.
      .catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }
  
  @LoaderEnabled()
  // LFWM-3699- api call to execute the search dynamic button
  public handlingSearchDynamicButtonAction(selectedLineItems: any) {
    const response$ = this.http$.post('api/rcmconfig/lineItem/sp', JSON.stringify(selectedLineItems))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.status === 403) {
          return Observable.throw(error.error.message);
        } else if (error.status === 504) {
          return Observable.throw(this.resourceService.get('msg_try_again_later'));
        } else if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
        return Observable.throw(error);
      });
    return response$;
  }
  @LoaderEnabled()
  public saveCopyValueToAllLineItems(req:any) {
    const response$ = this.http$.post(`/api/inventory/adjustment/copy/rows`, JSON.stringify(req))
    .map((response: any) => {
      return response;
    }).catch((error: any) => {
      if (error.error.length !== 0) {
        if (error.error.statusCode && error.error.statusCode !== 200) {
           return Observable.throw(error.error.statusMessage);
         } else if (error.status === 400 && error.error.errors) {
           return Observable.throw(error.error.errors['0'].defaultMessage + ' - ' +
           error.error.errors['0'].rejectedValue);
         }
       }
      return Observable.throw(error);
    });
  return response$;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/services/searchable-entity/detailed-entity/detailed-entity-backend.service.ts